import { Theme } from '@mui/material'

const useStyles = {
  activationTypeChip: (theme: Theme) => ({
    flexDirection: 'row-reverse',
    borderColor: theme.palette.action.selected,
    color: theme.palette.text.secondary,
    padding: '0 5px',
    width: '171px',
    height: '42px',
    borderRadius: theme.shape.extraLargeBorderRadius,

    '& .MuiChip-icon': {
      margin: '0 5px',
    },
  }),
  activationTypeChipSelected: (theme: Theme) => ({
    borderColor: 'transparent',
    backgroundColor: theme.palette.primary.shades['4p'],
    color: theme.palette.primary.dark,

    '&:hover': {
      backgroundColor: theme.palette.primary.shades['8p'],
    },
  }),
  pill: (theme: Theme) => ({
    display: 'flex',
    color: theme.palette.text.primary,
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '50px',
    padding: theme.spacing(0, 1),
    whiteSpace: 'nowrap',
  }),
  statusWaitingIcon: (theme: Theme) => ({
    color: theme.palette.primary.dark,
  }),
  thumbnail: {
    width: '98px',
    height: '98px',
    objectFit: 'cover' as const,
    borderRadius: '100px',
  },
  photoBtn: {
    textTransform: 'none',
  },
}
export default useStyles
